/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { UniversalLoader } from '~/components/UniversalLoader/UniversalLoader';
import ResponsiveHeader from '../../../../components/HeaderMobile';
import * as S from './styles';
import { PaymentPageComponent } from './components/PaymentPageComponent';

export function PaymentPage() {
  // const history = useHistory();
  const [initialLoading] = useState(false);

  return (
    <S.Container>
      <UniversalLoader open={initialLoading} />
      <ResponsiveHeader
        title="Detalhes do pagamento"
        url="/paymentmethods/configurationoffstorepay/accountbalance"
      />
      <S.Body>
        <PaymentPageComponent />
      </S.Body>
    </S.Container>
  );
}
